module.exports = __webpack_public_path__ + "img/icon-20-privacy.e017db21.svg";